import { Textures, configuratorBuilder } from 'algu-domain'
import { createI18n } from 'algu-i18n'
import { useEffect } from 'react'

import { ConfiguratorApp } from '@salsita-ai/platform-project-sdk/configurator'

import { AlguEnvironment } from './Environment'
import { tableComponents } from './entity-components/table'
import { topComponents } from './entity-components/top.js'
import { preset } from './systems/preset'
import { TEXTURE_QUERY_CACHE_OPTIONS, TextureProcessingMap } from './systems/resources'
import {
  fixOakLegsColorOnTopColorChange,
  fixOakTopColorOnMaterialChange,
} from './systems/transformers/fix-oak-color-transfomers'
import {
  fixLegsForCircleTop,
  fixLegsForNonCircleTop,
} from './systems/transformers/fix-table-legs-shape-update-transformer'
import { fixTableTopFenixVariantUpdateTransformer } from './systems/transformers/fix-table-top-fenix-variant-update-transformer'
import { fixTableTopMaterialUpdateTransformer } from './systems/transformers/fix-table-top-material-update-transformer'
import { useWebComponentLanguage, webComponentProperties } from './systems/web-component-properties.js'
import { theme } from './theme'

const i18n = createI18n()

export const config = configuratorBuilder
  .withDefaultEnvs({
    datadogEnabled: phoenix.runtimeConfig.DATADOG_ENABLED,
    datadogSite: phoenix.runtimeConfig.DATADOG_SITE,
    datadogClientToken: phoenix.runtimeConfig.DATADOG_CLIENT_TOKEN,
    deploymentId: phoenix.runtimeConfig.DEPLOYMENT_ID,
    gtmDebug: phoenix.runtimeConfig.GTM_DEBUG,
    gtmId: phoenix.runtimeConfig.GTM_ID,
    persistenceMode: phoenix.runtimeConfig.PERSISTENCE_MODE,
    serverUrl: phoenix.runtimeConfig.SERVER_URL,
    serviceName: phoenix.runtimeConfig.SERVICE_NAME,
  })
  .withVersion('0.1.1')
  .withWebComponentTag('salsita-3d-configurator')
  .withWebComponentOptions({ properties: webComponentProperties })
  .withPresets([preset])
  .withComponentOptics([...tableComponents, ...topComponents])
  .withWrappedApplication(config => {
    return () => {
      const language = useWebComponentLanguage()

      // initialize locale from host site
      useEffect(() => {
        if (language) {
          i18n.activate(language)
        }
      }, [language])

      return <ConfiguratorApp config={config} />
    }
  })
  .buildConfig({
    features: {
      availableLocales: phoenix.runtimeConfig.SHOW_LANGUAGE_TOOLBAR ? ['nl', 'fr', 'en'] : [],
      indicatorSwitch: false,
      share: {
        disabled: true,
        expiration: 240,
      },
    },
    ui: {
      theme,
      preview: 'never',
    },
    services: {
      i18n,
    },
    canvas: {
      canvasEnvironment: <AlguEnvironment />,
    },
    resources: {
      prefetchTextureUrls: Object.values(Textures),
      textureProcessingMap: TextureProcessingMap,
      textureQueryCacheOptions: TEXTURE_QUERY_CACHE_OPTIONS,
      baseResourcesUrl: phoenix.runtimeConfig.RESOURCES_URL,
    },
    createTransformers: ctx => [
      fixOakLegsColorOnTopColorChange.register(ctx),
      fixOakTopColorOnMaterialChange.register(ctx),
      fixLegsForCircleTop.register(ctx),
      fixLegsForNonCircleTop.register(ctx),
      fixTableTopMaterialUpdateTransformer.register(ctx),
      fixTableTopFenixVariantUpdateTransformer.register(ctx),
    ],
  })
